export default {
  GET_NOTIFICATIONS: (state) => state.notifications,
  GET_UNOPENED_NOTIFICATIONS: (state) => state.unopenedNotifications
};
